var render, staticRenderFns
import script from "./BackButton.vue?vue&type=script&lang=tsx"
export * from "./BackButton.vue?vue&type=script&lang=tsx"
import style0 from "./BackButton.vue?vue&type=style&index=0&id=355061bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355061bc",
  null
  
)

export default component.exports